import { HiddenTabMap, TabItem, TabMap } from 'store/types/Tabs';

/**
 * Compares mapping of all tabs to mapping of hidden tabs. Returns only the visible tabs.
 * @param {TabMap} tabs - Route of current page.
 * @param {HiddenTabMap} [hiddenTabs] - Optional - Array of visible tabs.
 */
export function getVisibleTabs(tabs: TabMap, hiddenTabs?: HiddenTabMap | null): TabItem[] {
  return Object.entries(tabs)
    .filter(([key]) => !hiddenTabs?.[key])
    .map(([key, tab]) => ({
      key: key,
      label: tab.label,
      route: tab.route,
    }));
}

/**
 * If the current route is a visible tab, then returns the current tab route.
 * If the current route is not a visible tab, returns the first visible tab route.
 * @param {string} currentRoute - Route of current page.
 * @param {TabItem[]} visibleTabs - Array of visible tabs.
 */
export function getDefaultTabRoute(currentRoute: string, visibleTabs: TabItem[]): string {
  const currentTabKey = visibleTabs.find((tab) => tab.route === currentRoute);
  return currentTabKey?.route ?? visibleTabs[0].route;
}
